import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetLostInquiryAnalysisReport } from "../services/reports.services";

const LostInquiryAnalysisReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/lostinquiryanalysisreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/lostinquiryanalysisreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterDestination = params?.filterDestination;
  const AssignedUser = params?.AssignedUser;

  const loading = useAppSelector((state) => state.reports.loading);
  const LostInquiryAnalysisListForReport = useAppSelector(
    (state) => state.reports.LostInquiryAnalysisListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        Destination: filterDestination !== "0" ? filterDestination : "",
        AssignUser: AssignedUser !== "0" ? AssignedUser : "",
      };
      dispatch(GetLostInquiryAnalysisReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "LostInquiryAnalysisReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "lostinquiryanalysisreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Lost Inquiry Analysis Report{" "}
          <span style={{ fontSize: 15 }}>
            {LostInquiryAnalysisListForReport &&
              LostInquiryAnalysisListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            LostInquiryAnalysisListForReport &&
            LostInquiryAnalysisListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            LostInquiryAnalysisListForReport &&
            LostInquiryAnalysisListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {LostInquiryAnalysisListForReport &&
      LostInquiryAnalysisListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Inquiry ID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Customer Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Destination
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Assigned User
                </th>
                {/* <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Closed Date
                </th> */}
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Lost Reason
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Inquiry Age
                </th>
              </tr>
            </thead>
            <tbody>
              {LostInquiryAnalysisListForReport &&
                LostInquiryAnalysisListForReport.length > 0 &&
                LostInquiryAnalysisListForReport?.map(
                  (LostInquiryAnalysis: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {LostInquiryAnalysis?.InquiryID || ""}
                      </td>
                      <td className="text-center">
                        {LostInquiryAnalysis?.CustomerName || ""}
                      </td>
                      <td className="text-center">
                        {LostInquiryAnalysis?.Destination || ""}
                      </td>
                      <td className="text-center">
                        {LostInquiryAnalysis?.AssignUser || ""}
                      </td>
                      {/* <td className="text-center">
                        {LostInquiryAnalysis?.ClosedDate
                          ? moment(
                              LostInquiryAnalysis?.ClosedDate,
                              "DD/MM/YYYY"
                            ).format("DD MMM YYYY")
                          : ""}
                      </td> */}
                      <td className="text-center">
                        {LostInquiryAnalysis?.LostReason || ""}
                      </td>
                      <td className="text-center">
                        {LostInquiryAnalysis?.InquiryAge || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default LostInquiryAnalysisReportView;
